import { render, staticRenderFns } from "./SubscriptionsList.vue?vue&type=template&id=a24aa630&scoped=true&"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsList.vue?vue&type=style&index=0&id=a24aa630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24aa630",
  null
  
)

export default component.exports